
export const clientVersion = "2.1.3";

export const clientInfoVersion = "2.1.3.Sha.794c65c71798cc69280cd645aeec508f55da4a26";

